import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { BaasEdgePoolsPayload } from '~src/settings/dataconnect-settings/sections/types/BaasEdgePoolsPayload';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IGetBaasEdgePoolsParams {
  siteId: string;
}

export interface IGetBaasEdgePoolsResult extends IResult {
  success?: BaasEdgePoolsPayload;
  error?: BaasEdgePoolError;
}

export class GetBaasEdgePoolsRequest extends Request<IGetBaasEdgePoolsParams, IGetBaasEdgePoolsResult> {
  constructor(params: IGetBaasEdgePoolsParams) {
    super('getBaasEdgePools', params);
  }
}
